import { Box, Typography } from '@mui/material'
import InError from 'components/error'
import Loading from 'components/loading'
import { useProject } from 'contexts/project'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import ProjectConnectGoogleDrive from './google-drive'
import { useStyles } from './styles'

interface IRouteParams {
  id: string
  key: string
}

const ConnectorConnect = () => {
  const { data: project, changeProjectId, isLoading, refreshData, isError } = useProject()
  const { key, id } = useParams<IRouteParams>()
  const classes = useStyles()

  useEffect(() => {
    if (id) {
      changeProjectId(id)
    }
  }, [id, isLoading])

  if (isLoading) {
    return (
      <Box className={classes.root}>
        <Loading />
      </Box>
    )
  }

  if (isError) {
    return <InError message='Error ao Carregar o Projeto' />
  }

  const connectorWithKey = project.connectors.find((item) => item.key === key)

  if (!connectorWithKey) {
    return (
      <Box className={classes.root}>
        <Typography> Connector não Encontrado </Typography>
      </Box>
    )
  }

  if (key === 'google-drive') {
    return (
      <ProjectConnectGoogleDrive
        keyName={key}
        project={project}
        refreshData={refreshData}
      />
    )
  } else {
    return (
      <Box className={classes.root}>
        <Typography> Connector não Encontrado </Typography>
      </Box>
    )
  }
}

export default ConnectorConnect
